import React from "react";
import Layout from "../layout/Layout";
import Banner from "../components/data-enrichment/Banner";
import IndustryLeaders from "../components/industry-leaders/industry-leaders";
import FeatureGrid from "../components/data-enrichment/FeatureGrid";
import Cta from "../components/data-enrichment/Cta";
import Testimonials from "../components/data-enrichment/Testimonials";

const DataEnrich = () => {
  return (
    <Layout>
      <Banner />
      <IndustryLeaders />
      <FeatureGrid />
      <Cta />
      <Testimonials />
    </Layout>
  );
};

export default DataEnrich;
